import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButton';

(function (once, Drupal) {
  Drupal.behaviors.emblaBehavior = {
    attach: function (context, settings) {
      once('emblaBehavior', 'div.embla', context).forEach(function (rootNode) {
        // Grab wrapper nodes
        const viewportNode = rootNode.querySelector('.embla__viewport');

        // Grab button nodes
        const prevButtonNode = rootNode.querySelector('.embla__prev');
        const nextButtonNode = rootNode.querySelector('.embla__next');

        // Get the dots
        const dotsNode = rootNode.querySelector('.embla__dots');

        // Parse options from data-options attribute
        const emblaOptions = rootNode.dataset.options;
        console.log(emblaOptions);

        const options = emblaOptions ? JSON.parse(emblaOptions) : {};

        // ✅ Count slides
        const slideCount = viewportNode
          ? viewportNode.querySelectorAll('.embla__container > *').length
          : 0;

        // ✅ Hide navigation and dots if <= 1 slide
        if (slideCount <= 1) {
          if (prevButtonNode) prevButtonNode.style.display = 'none';
          if (nextButtonNode) nextButtonNode.style.display = 'none';
          if (dotsNode) dotsNode.style.display = 'none';
          return;
        }

        const PAUSE_DURATION = 3000; // Pause for 3 seconds

        // ✅ Create autoplay plugin instance
        const autoplay = Autoplay({ delay: 4000, stopOnInteraction: false });

        // ✅ Initialize Embla with autoplay plugin
        const embla = EmblaCarousel(viewportNode, options, [autoplay]);

        // Add click listeners
        function pauseAutoplay() {
          autoplay.stop();
          setTimeout(() => {
            options.autoPlay && autoplay.play();
          }, PAUSE_DURATION);
        }

        pauseAutoplay(); // This will pause autoplay when the carousel is initialized

        if (prevButtonNode)
          prevButtonNode.addEventListener(
            'click',
            () => {
              embla.scrollPrev();
              pauseAutoplay(); // 👈 Pause autoplay on prev click;
            },
            false
          );

        if (nextButtonNode)
          nextButtonNode.addEventListener(
            'click',
            () => {
              embla.scrollNext();
              pauseAutoplay(); // 👈 Pause autoplay on next click;
            },
            false
          );

        // Setup dot navigation
        if (dotsNode) {
          const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
            embla,
            dotsNode,
            () => {
              autoplay.reset(); // 👈 Reset autoplay on dot click
            }
          );
          embla.on('destroy', removeDotBtnsAndClickHandlers);
        }

        // Display active slide number (for lightbox)
        const setActiveSlide = () => {
          const activeSlideIndex = embla.selectedScrollSnap();
          const currentSlideEl = document.querySelector(
            '.lightbox .current-slide'
          );
          if (currentSlideEl) currentSlideEl.textContent = activeSlideIndex + 1;
        };
        embla.on('select', setActiveSlide);

        // Adjust navigation offset based on image height
        const setNavTopOffset = () => {
          const images = viewportNode.querySelectorAll('img');
          let maxHeight = 0;
          images.forEach((img) => {
            if (img.clientHeight > maxHeight) {
              maxHeight = img.clientHeight;
            }
          });

          if (maxHeight > 0) {
            rootNode.style.setProperty(
              '--embla-navigation-top-offset',
              `${maxHeight / 2}px`
            );
          } else {
            maxHeight = viewportNode.clientHeight;
            rootNode.style.setProperty(
              '--embla-navigation-top-offset',
              `${maxHeight / 2}px`
            );
          }
        };
        embla.on('init', setNavTopOffset);
        embla.on('resize', setNavTopOffset);
      });
    },
  };
})(once, Drupal);
